import React from "react"
import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useDisclosure
} from "@chakra-ui/react"
import {useForm} from "react-hook-form"
import {InformationCircleIcon} from "@heroicons/react/20/solid"

import {OrganizationForm} from "@modules/user/components/Forms"
import {userApiCalls} from "@modules/user/service"


export function WorkModal({user}) {
    const {isOpen, onOpen, onClose} = useDisclosure({defaultIsOpen: true})

    const {
        handleSubmit,
        register,
        control,
        getValues,
        setValue,
        formState: {
            errors,
            isSubmitting
        }
    } = useForm({})

    async function onSubmit(values) {
        const {work} = values

        if (work.jobTitle !== "Other") {
            work.jobTitleOther = null
        }

        const saveData = Object.keys(work).reduce((acc, key) => {

            if (!work[key] || (Array.isArray(work[key]) && !work[key].length))
                return acc

            acc[key] = work[key]

            return acc
        }, {})


        await userApiCalls
            .currentUserUpdate({work: saveData})

        onClose()
    }

    async function onModalClose() {
        await userApiCalls
            .currentUserUpdate({work: {hideOnStart: true}})
        onClose()
    }

    return (
        <>
            <Modal isOpen={isOpen} onClose={onModalClose}>
                <ModalOverlay/>
                <ModalContent>
                    <ModalHeader>Organization Info</ModalHeader>
                    <ModalCloseButton onClick={onModalClose}/>
                    <ModalBody>
                        <OrganizationForm register={register} errors={errors} setValue={setValue} control={control}/>
                        <div className="rounded-md bg-blue-50 p-4 mt-4">
                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <InformationCircleIcon className="h-5 w-5 text-blue-400" aria-hidden="true"/>
                                </div>
                                <div className="ml-3 flex-1 md:flex md:justify-between">
                                    <p className="text-sm text-blue-700">You can update it again at any time on the
                                        Profile Page.</p>
                                </div>
                            </div>
                        </div>
                    </ModalBody>

                    <ModalFooter flex="auto" justifyContent="space-between">
                        <Button onClick={onModalClose}>Close</Button>
                        <Button colorScheme="blue"
                                isLoading={isSubmitting}
                                onClick={handleSubmit(onSubmit)}>
                            Update & Close
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}